module.exports = __webpack_public_path__ + "static/img/appriana-delight.f66e3eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appriana-delight.png
// module id = T3vX
// module chunks = 1